import {IDownloadLinks} from '../../../typings/general';
import {TAlbum, TTrack} from '../../../typings/todo';
import {InitialTransactionStatus} from '../../services/cashier/getTransactionInfo';
import {ISiteInfo} from '../../services/env/siteInfo/siteInfoContext';
import {ExperimentBag} from '../../services/experiments/ExperimentBag';
import {Player} from '../../services/player/player';
import {GET_CONTAINER_DISPLAY_M} from '../getContainerDisplay';

export class AppContext {
  album: TAlbum;
  track: TTrack | undefined = undefined;
  email: string | undefined = undefined;
  downloadLinks: IDownloadLinks | undefined = undefined;
  snapshotId: string | undefined = undefined;
  error: unknown = undefined;
  cashierWidgetLoading: boolean = true;
  experiments: ExperimentBag = {};
  siteInfo: ISiteInfo | undefined = undefined;
  siteSettings: unknown = undefined;
  priceOverride: number | undefined = undefined;
  isIos: boolean = false;
  paymentErrorMessage: string | undefined = undefined;
  hasSubscribeError: boolean = false;
  initialTransactionStatus: InitialTransactionStatus | undefined;
  player: Player | undefined;
  mandatoryFields: Record<string, string> | undefined;

  constructor(data: {album: TAlbum} & Partial<AppContext>) {
    Object.assign(this, data);
  }
}

export interface TMeta {
  show?: GET_CONTAINER_DISPLAY_M;
}
